const formatTime = (time: string) => {
    const t = new Date(time).toLocaleTimeString('en-US', { hour12: true });
    return t.slice(0, t.length - 6) + t.slice(t.length - 3, t.length);
};

export default formatTime;